import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import './DatePickerForm.scss';

const DatePickerForm = (props) => {
	return (
		<div className={`${props.customClassLayout ? props.customClassLayout : 'date-upper-layout'}`}>
			{!!props.dateHeader && <div className="date-header-style">{props.dateHeader}</div>}
			<div className={`${props.customClassDateStyle ? props.customClassDateStyle : 'date-style'}`}>
				<div className="picker-style">
					<DatePicker
						value={props.value ? moment(props.value) : null}
						className={props.classDatePicker}
						onChange={(date, dateString) => {
							props.onChange(date, dateString);
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default DatePickerForm;
